const state = () => ({
    openDialog: false,
    waiversUser: [],
    membershipWaiversRaw: [],
    membershipWaiversByRider: {},
    bSendWaiver: false,
    roleActive: 'Spectator',
    waiverData: {}
});

const mutations = {
    SET_OPEN_DIALOG(state, value) {
        state.openDialog = value;
    },
    SET_WAIVERS_USER(state, value) {
        state.waiversUser = value;
    },
    SET_MEMBERSHIP_WAIVERS_RAW(state, value) {
        state.membershipWaiversRaw = Array.isArray(value) ? value : [];
    },
    SET_MEMBERSHIP_WAIVERS_BY_RIDER(state, value) {
        state.membershipWaiversByRider = value && typeof value === 'object' ? value : {};
    },
    SET_B_SEND_WAIVER(state, value) {
        state.bSendWaiver = value;
    },
    SET_ROLE_ACTIVE(state, value) {
        state.roleActive = value
    },
    SET_WAIVER_DATA(state, value) {
        state.waiverData = value;
    }
}

const getters = {
    GET_OPEN_DIALOG: (state) => state.openDialog,
    GET_WAIVERS_USER: (state) => state.waiversUser,
    GET_MEMBERSHIP_WAIVERS_RAW: (state) => state.membershipWaiversRaw,
    GET_MEMBERSHIP_WAIVERS_BY_RIDER: (state) => state.membershipWaiversByRider,
    GET_B_SEND_WAIVER: (state) => state.bSendWaiver,
    GET_ROLE_ACTIVE: (state) => state.roleActive,
    GET_WAIVER_DATA: (state) => state.waiverData
}

const actions = {
    SET_OPEN_WAIVER_DIALOG_ACTION(context,value) {  
        context.commit('SET_OPEN_DIALOG', value)
    },
    SET_WAIVERS_FOR_DIALOG_ACTION(context, value) {
        context.commit('SET_WAIVERS_USER', value)
    },
    SET_MEMBERSHIP_WAIVERS_RAW_ACTION(context, value) {
        context.commit('SET_MEMBERSHIP_WAIVERS_RAW', value)
    },
    SET_MEMBERSHIP_WAIVERS_BY_RIDER_ACTION(context, value) {
        context.commit('SET_MEMBERSHIP_WAIVERS_BY_RIDER', value)
    },
    SET_B_SEND_WAIVER_FOR_DIALOG_ACTION(context, value) {
        context.commit('SET_B_SEND_WAIVER', value)
    },
    SET_ROLE_ACTIVE_ACTION(context, value) {
        context.commit('SET_ROLE_ACTIVE', value)
    },
    SET_WAIVER_DATA_ACTION(context, value) {
        context.commit('SET_WAIVER_DATA', value)
    }
}

export default {
    state, mutations, actions, getters
  }